import { type GiftVoucherModuleSpecsFragment } from '../../../../api/fragments/GiftVoucherModuleSpecs';
import GiftVoucherModuleDetails from './GiftVoucherModuleDetails';
import GiftVoucherModuleEmail from './GiftVoucherModuleEmail';
import { HeaderTabs } from './shared';

export type GiftVoucherModuleDetailsInnerProps = {
    module: GiftVoucherModuleSpecsFragment;
    activeTab: HeaderTabs;
};

const GiftVoucherModuleDetailsInner = ({ module, activeTab }: GiftVoucherModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return <GiftVoucherModuleDetails module={module} />;

        case HeaderTabs.Email:
            return <GiftVoucherModuleEmail module={module} />;

        default:
            throw new Error('HeaderTabs not support');
    }
};

export default GiftVoucherModuleDetailsInner;
